import { IconButton, Tooltip } from '@mui/material';
import { Doc } from 'src/@types/docs';
import { useLocales } from 'src/locales';
import { useDocFavoriteMutation } from '../../../../shared/useDocFavoritedMutation';
import { useDocHeaderActions } from '../useDocHeaderActions';
import { DocFavoriteIcon } from './DocFavoriteIcon';

export const FavoriteDocHeaderAction = ({ doc }: { doc: Doc }) => {
  const { handleFavorite } = useDocHeaderActions({ doc });
  const { isFavoritingDoc, isDisfavoringDoc } = useDocFavoriteMutation();
  const { translate } = useLocales();
  return (
    <Tooltip
      arrow
      title={
        doc.starred
          ? translate('collaborate.docs.disfavor_doc')
          : translate('collaborate.docs.favorite_doc')
      }
    >
      <IconButton
        onClick={handleFavorite}
        disabled={isFavoritingDoc || isDisfavoringDoc}
      >
        <DocFavoriteIcon starred={doc.starred} />
      </IconButton>
    </Tooltip>
  );
};
